import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { getContactById } from "../../redux/actions/contactAction";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { contactDetails } from "../../Typings/dataListing";
import { hasPermission } from "../../config/permissionUtils";
const ContactsView: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();

  const dispatch = useDispatch<AppDispatch>();
  const [Contactlist, setContactList] = useState<contactDetails | null>(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getContactData();
  }, []);

  const getContactData = async () => {
    const payload = { id: id };
    try {
      dispatch(
        getContactById(payload, (response: any) => {
          const ContactData = response?.data;
          if (ContactData) {
            setContactList(ContactData);
          }
        })
      );
    } catch (error) {
      console.error("Error fetching farm details:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">Contacts</span>
              {Contactlist?.id || "-"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                ID{" "}
                <span className="d-block pt-1">{Contactlist?.id || "-"}</span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                County{" "}
                <span className="d-block pt-1">
                  {Contactlist?.county || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Office{" "}
                <span className="d-block pt-1">
                  {Contactlist?.office || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Agent First Name{" "}
                <span className="d-block pt-1">
                  {Contactlist?.agent_first_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Agent Last Name{" "}
                <span className="d-block pt-1">
                  {Contactlist?.agent_last_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Title{" "}
                <span className="d-block pt-1">
                  {Contactlist?.title || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Address Line 1{" "}
                <span className="d-block pt-1">
                  {Contactlist?.address_line_1 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Address Line 2{" "}
                <span className="d-block pt-1">
                  {Contactlist?.address_line_2 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                City{" "}
                <span className="d-block pt-1">{Contactlist?.city || "-"}</span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                State{" "}
                <span className="d-block pt-1">
                  {Contactlist?.state || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                ZIP/Postal Code{" "}
                <span className="d-block pt-1">
                  {Contactlist?.zip_postal_code || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Phone Number{" "}
                <span className="d-block pt-1">
                  {Contactlist?.phone_number || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Email Address{" "}
                <span className="d-block pt-1">
                  {Contactlist?.email_address || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Source{" "}
                <span className="d-block pt-1">
                  {Contactlist?.source || "-"}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              <NavLink to="/Contacts">
                <button type="button" className="formBtn cancel">
                  Cancel
                </button>
              </NavLink>
              {hasPermission(permissions, roleid, "Farm Profile", "edit") && (
                <NavLink
                  to={{
                    pathname: "/Contacts/edit/" + Contactlist?.id,
                  }}
                  title="Edit"
                >
                  <button type="button" className="ms-3 formBtn">
                    Edit Details
                  </button>
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ContactsView;
